module.exports = __webpack_public_path__ + "img/back.350f490b.svg";